import classNames from "classnames";
import useTranslation from "hooks/useTranslation";
import { ChevronRight, Lock } from "lucide-react";
import React from "react";

export const SidebarMenuButton = ({
	icon,
	title,
	isOpen,
	onClick,
	isActive,
	isLocked
}) => {
	const { tr } = useTranslation();

	return (
		<div
			className={classNames({
				"flex items-center gap-3 hover:bg-[#00359E] text-[#D1E0FF] group-hover:text-white group select-none cursor-pointer duration-200 h-10 px-3 rounded-md relative": true,
				"!bg-[#00359E] !text-white": isActive,
				"opacity-50 !text-white !cursor-not-allowed": isLocked
			})}
			onClick={isLocked ? undefined : onClick}
		>
			{icon}

			<div className="">{tr(title)}</div>

			{isLocked ? (
				<Lock
					className={classNames({
						"ml-auto text-[#84ADFF] duration-150 size-4": true
					})}
				/>
			) : (
				<ChevronRight
					className={classNames({
						"ml-auto text-[#84ADFF] duration-150": true,
						"rotate-90": isOpen
					})}
				/>
			)}
		</div>
	);
};
